import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useAntenatalConsultations = (pregnancyId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    // Key matches PregnancyGeneralView key — shared cache
    queryKey: ["anteNatalConsultations", pregnancyId, tenantVal],
    queryFn: async () => {
      const axios = createAxiosInstance();
      const response = await axios.get(
        `${tenantVal}/antenatalconsultation/getbypregnancyid/${pregnancyId}`
      );
      return response.data?.data ?? response.data;
    },
    enabled: !!pregnancyId && !!tenantVal,
  });
};
